'use strict';

class ParticipantEdit {
  constructor($scope, $routeParams, $filter, $location, eventService, recipientService, I18N, Notification) {
    this.$scope = $scope;
    this.$filter = $filter;
    this.$location = $location;
    this.eventService = eventService;
    this.recipientService = recipientService;
    this.I18N = I18N;
    this.Notification = Notification;

    this.eventNumber = $routeParams.number;
    this.participantNumber = $routeParams.participantNumber;
  }

  $onInit() {
    this.participant = {
      name: null,
      email: null,
      mobile: null,
      customFields: [],
      eventPrice: 0
    };

    this.recipientNumber = null;

    this.newRecipient = false;
    this.showSms = false;
    this.params = {
      sms: null,
      copy: null
    };
    this.discountCodes = [];

    this.$scope.$on('recipientNumber', (e, val) => {
      this.recipientNumber = val;
    });

    this.$scope.$on('newRecipient', (e, val) => {
      this.newRecipient = val;
    });

    this.loadDiscountCodes();
    this.loadParticipant();
  }

  loadDiscountCodes() {
    this.eventService.loadDiscountCode(this.eventNumber)
      .then((resp) => {
        if (resp.data && resp.data.codes) {
          resp.data.codes.forEach((item) => {
            this.discountCodes.push(item.code);
          }, this);
        }
      });
  }

  loadParticipant() {
    this.eventService.getParticipant(this.eventNumber, this.participantNumber)
      .then((resp) => {
        // fix ISO format for DATE fields
        if (resp.data.customFields && resp.data.customFields.length) {
          resp.data.customFields = resp.data.customFields.map((field) => {
            if (field.type === 'DATE' && field.value !== null && field.value !== '') {
              field.value = moment(field.value, 'YYYY-MM-DD').format('DD.MM.YYYY');
            }

            return field;
          });
        }

        this.participant = resp.data;

        // copy mobile to sms field
        this.params.sms = {
          phoneNumber: resp.data.mobile,
          message: `${this.originator.name} har sendt deg en faktura, se fakturaen på:`
        };

        // get recipient number
        this.recipientNumber = resp.data._links.recipient ? this.$filter('urlParser')(resp.data._links.recipient.uri, 2) : null;
      });
  }

  /**
   * Prepare a recipient and confirm it
   */
  createRecipient() {
    this.recipientService.suggestCustomerNumber()
      .then((json) => json.data)
      .then((resp) => {
        return {
          id: null,
          number: null,
          customerNumber: resp.customerNumber || null,
          name: this.participant.invoice.name || null,
          contact: {
            address: {
              address1: this.participant.invoice.address || null,
              address2: null,
              city: this.participant.invoice.city || null,
              country: this.participant.invoice.country || 'NORGE',
              zip: this.participant.invoice.zip || null
            },
            email: this.participant.email || null,
            phone: null,
            mobile: this.participant.mobile || null,
            fax: null,
            web: null
          },
          organisation: {
            form: 'prv',
            icd: this.participant.invoice.icd || '9908',
            number: this.participant.invoice.orgNo || null
          },
          settings: {
            discount: 0,
            creditDays: null,
            defaultShipment: null,
            currency: null,
            lost: false
          },
          avtaleGiro: null,
          yourRef: this.participant.invoice.yourRef || null,
          customFields: [],
          comment: null,
          deleted: false
        };
      })
      .then((recipient) => {
        this.recipientService.save(recipient)
          .then((resp) => {
            this.recipientNumber = this.$filter('urlParser')(resp.headers().location, 4);
            this.process();
          });
      });
  }

  /**
   * Confirm participant with the neccessary params
   */
  process() {
    if (this.recipientNumber) {
      this.params.recipientNumber = this.recipientNumber;
    }

    if (!this.showSms) {
      this.params.sms = null;
    }

    this.eventService.confirmParticipant(this.eventNumber, this.participantNumber, this.params)
      .then(() => this.$location.path(`/vert/${this.eventNumber}/deltagere`));
  }

  /**
   * Save the participant
   */
  save() {
    if (this.participant.customFields) {
      this.participant.customFields.map((field) => {
        if (field.type === 'DATE' && moment(field.value, 'DD.MM.YYYY').isValid()) {
          field.value = moment(field.value, 'DD.MM.YYYY').format('YYYY-MM-DD');
        }

        return field;
      });
    }

    this.eventService.updateParticipant(this.eventNumber, this.participantNumber, this.participant)
      .then(() => this.loadParticipant());
  }

  /**
   * Confrim participant and send the invoice if neccessary
   */
  confirm() {
    if (this.newRecipient) {
      this.createRecipient();
    } else {
      this.process(this.recipientNumber);
    }
  }

  /**
   * Confirm participant and send the invoice if neccessary
   */
  updateInvoiceDataAndConfirm() {
    this.eventService.updateParticipantInvoiceData(this.eventNumber, this.participantNumber, this.participant)
      .then(() => this.confirm());
  }
}

ParticipantEdit.$inject = ['$scope', '$routeParams', '$filter', '$location', 'eventService', 'recipientService', 'I18N', 'Notification'];

const participantEdit = {
  bindings: {
    originator: '<'
  },
  controller: ParticipantEdit,
  templateUrl: 'event/participant.html'
};

angular
  .module('SendRegning')
  .component('participantEdit', participantEdit)
  .config(($routeProvider) => {
    $routeProvider
      .when('/vert/:number/deltagere/:participantNumber', {
        title: 'Deltager',
        template: '<participant-edit originator="$resolve.originator" />',
        secure: true,
        resolve: {
          originator: (originatorService) => originatorService.get().then((resp) => resp.data)
        }
      });
  });
